// To get image gallery to work with alt tags #option_value / #serie_1

(function () {
  function getSerieTag(alt) {
    if (!alt) return null;
    const match = alt.match(/#(.+)$/);
    return match ? match[1].toLowerCase() : null;
  }

  function filterGallery(variant) {
    if (!variant) return;

    // Get the serie tag from the variant's featured media alt text
    const featuredAlt = variant.featured_media?.alt || variant.featured_image?.alt;
    const activeTag = getSerieTag(featuredAlt);

    const allSlides = document.querySelectorAll('.product__media-item[data-media-alt]');
    const allThumbs = document.querySelectorAll('.thumbnail-list__item[data-media-alt]');

    [...allSlides, ...allThumbs].forEach((el) => {
      const tag = getSerieTag(el.dataset.mediaAlt);

      if (!tag) {
        // No tag = shared image, always show
        el.style.display = '';
      } else if (!activeTag) {
        // Variant has no featured media tag, show everything
        el.style.display = '';
      } else {
        el.style.display = tag === activeTag ? '' : 'none';
      }
    });
  }

  function waitForPubSub(attempts) {
    if (attempts <= 0) return;

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        const variant = event?.data?.variant;
        setTimeout(() => filterGallery(variant), 50);
      });

      // Filter on page load
      document.addEventListener('DOMContentLoaded', function () {
        const selectedVariantEl = document.querySelector(
          'variant-selects [data-selected-variant]'
        );
        if (selectedVariantEl) {
          try {
            const variant = JSON.parse(selectedVariantEl.innerHTML);
            filterGallery(variant);
          } catch (e) {}
        }
      });
    } else {
      setTimeout(() => waitForPubSub(attempts - 1), 100);
    }
  }

  waitForPubSub(20);
})();